/**
 * Footer del frontend-superadmin.
 *
 * Sprint 11 v2 S11-V2-11. Espejo del Footer del portal con diferencias:
 * - Sub "Acceso técnico" en lugar de "Portal privado".
 * - Borde superior admin-red.
 * - Sin link "Datos para transferir" (super_admin no transfiere).
 *
 * Sprint 16 S16-10: incluye `<FooterVersion />` fijo en módulo
 * Administración para diagnóstico de "qué hay deployado".
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/auth/AuthContext';
import { FooterVersion } from './FooterVersion';

export function Footer() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <footer className="bg-bg-page border-t-2 border-admin-red px-8 py-5 flex flex-wrap justify-between items-center gap-4 text-sm text-text-primary">
      <div className="flex items-center gap-2">
        <span className="text-admin-red font-medium">Barrio</span>
        <span className="text-text-primary font-medium tracking-wider">CALBUCURA</span>
        <span className="opacity-60 ml-2">· Acceso técnico</span>
      </div>
      <div className="flex items-center gap-5">
        <FooterVersion />
        <button
          type="button"
          onClick={handleLogout}
          className="opacity-85 hover:opacity-100 hover:underline underline-offset-2 transition-opacity duration-base"
        >
          Cerrar sesión
        </button>
      </div>
    </footer>
  );
}
